import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useDebounce from '../../hooks/useDebounce';
import {changeField, readWordList} from '../../modules/admin/voca';
import VocaList from '../../components/admin/voca/VocaList';

export default function VocaListContainer() {
    const dispatch = useDispatch();

    const { standardWord, useWord, page, category, listResponse, listErrorResponse, pagination, listLoading} = useSelector(({ voca, loading}) => ({
        standardWord: voca.standardWord,
        useWord: voca.useWord,
        page: voca.page,
        category: voca.category,
        listResponse: voca.listResponse,
        listErrorResponse: voca.listErrorResponse,
        pagination: voca.pagination,
        listLoading: loading['voca/READ_WORD_LIST']
    }));

    const debouncedStandardWord = useDebounce(standardWord, 1000);
    const debouncedUseWord = useDebounce(useWord, 1000);

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(changeField({ name, value }));
    };

    useEffect(() => {
        dispatch(readWordList({
            standardWord: debouncedStandardWord ? debouncedStandardWord.trim() : null,
            useWord: debouncedUseWord ? debouncedUseWord.trim() : null,
            category,
            page
        }));
    }, [dispatch, debouncedStandardWord, debouncedUseWord, category, page]);

    return (
        <VocaList standardWord={standardWord}
                  useWord={useWord}
                  category={category}
                  listResponse={listResponse}
                  listErrorResponse={listErrorResponse}
                  pagination={pagination}
                  listLoading={listLoading}
                  handleChange={handleChange}
        />
    );
}
